import { useState } from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import { ChevronDownIcon } from "@heroicons/react/16/solid";
import {
  BellIcon,
  CalendarDaysIcon,
  UserIcon,
} from "@heroicons/react/20/solid";
import TaskCalendarToday from "./taskcalendartoday";
import TaskNow from "./taskmanager";
import TaskTraining from "./tasktraining";
import { DocumentPlusIcon } from "@heroicons/react/24/solid";
import WorkCoach from "./workcoach";

const tabs = [
  { name: "My Tasks", component: <TaskCalendarToday />, icon: BellIcon },
  { name: "Team Tasks", url: "/team-tasks", icon: CalendarDaysIcon }, // Navigate to this URL
  {name: 'Bottleneck Analysis', url: "/bottleneck-analysis", icon: UserIcon},
  {name: 'Process/SOPs', url:  "/process-creator", icon: DocumentPlusIcon},
  { name: "Task Calendar", url: "/taskcalendar", icon: CalendarDaysIcon },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Example() {
  const [currentTabIndex, setCurrentTabIndex] = useState(0); // Default to the first tab
  const navigate = useNavigate(); // Initialize useNavigate

  const handleTabChange = (index) => {
    const selectedTab = tabs[index];

    if (selectedTab.url) {
      navigate(selectedTab.url); // Navigate to the route instead of changing state
    } else {
      setCurrentTabIndex(index);
    }
  };

  return (
    <div data-component="task-home" className="sm:pb-0 pb-20">

      <div className="hidden sm:block">
        {/* Desktop version - horizontal tab navigation with enhanced styling */}
        <div className="bg-gradient-to-r from-purple-500 to-violet-600 rounded-lg shadow-lg p-1 flex justify-center">
          <nav aria-label="Tabs" className="flex space-x-1">
            {tabs.map((tab, index) => (
              <button
                key={tab.name}
                onClick={() => {
                  if (tab.url) {
                    navigate(tab.url); // Use navigate from react-router-dom to navigate to the URL
                  } else {
                    handleTabChange(index); // Handle tab switch for other tabs
                  }
                }}
                data-component="task-home-tab"
                data-feature={tab.url ? `navigate-${tab.name.replace(/\s+/g, '-').toLowerCase()}` : `switch-${tab.name.replace(/\s+/g, '-').toLowerCase()}`}
                className={classNames(
                  currentTabIndex === index
                    ? 'bg-white text-purple-700 shadow-md'
                    : 'text-white hover:bg-white/20',
                  'rounded-md px-4 py-3 text-sm font-medium flex items-center transition-all duration-200'
                )}
              >
                {tab.icon && (
                  <tab.icon 
                    className={classNames(
                      currentTabIndex === index ? 'text-purple-600' : 'text-white',
                      'mr-2 h-5 w-5'
                    )} 
                    aria-hidden="true" 
                  />
                )}
                {tab.name}
              </button>
            ))}
          </nav>
        </div>
      </div>

      {/* Render the content of the selected tab */}
      <div className="mt-4">
        {tabs[currentTabIndex].component && tabs[currentTabIndex].component}
        {!tabs[currentTabIndex].component && tabs[currentTabIndex].url && (
          <div className="flex justify-center items-center p-8 text-gray-500">
            <p>Navigating to {tabs[currentTabIndex].url}...</p>
          </div>
        )}
      </div>

      {/* Mobile bottom swipeable tab bar */}
      <div className="sm:hidden fixed bottom-0 left-0 right-0 z-50">
        <div className="bg-gradient-to-r from-purple-600 via-purple-500 to-violet-500 p-2 shadow-2xl">
          <div className="overflow-x-auto flex space-x-2 hide-scrollbar px-1">
            {tabs.map((tab, index) => (
              <button
                key={`mobile-bottom-${tab.name}`}
                onClick={() => {
                  if (tab.url) {
                    navigate(tab.url);
                  } else {
                    handleTabChange(index);
                  }
                }}
                data-component="task-home-tab"
                data-feature={tab.url ? `navigate-${tab.name.replace(/\s+/g, '-').toLowerCase()}` : `switch-${tab.name.replace(/\s+/g, '-').toLowerCase()}`}
                className={classNames(
                  currentTabIndex === index
                    ? 'bg-white text-purple-700 shadow-md'
                    : 'bg-purple-600/40 text-white hover:bg-purple-700/70',
                  'whitespace-nowrap px-3 py-2 text-xs font-semibold rounded-full flex-shrink-0 transition-all duration-200 flex items-center min-w-[110px] justify-center'
                )}
              >
                {tab.icon && (
                  <tab.icon
                    className={classNames(
                      currentTabIndex === index ? 'text-purple-600' : 'text-white',
                      'mr-1 h-4 w-4'
                    )}
                  />
                )}
                {tab.name}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
